import { RefObject, useLayoutEffect } from "react";

export const HEALTH_NAV_OFFSET_CSS_VAR = "--health-nav-offset";

const HEALTH_NAV_OFFSET_FALLBACK_PX = 80;

export function syncHealthNavOffsetCssVar(
    element?: HTMLElement | null
): void {
    const nav =
        element ?? document.querySelector<HTMLElement>("[data-site-nav]");
    if (!nav) return;

    document.documentElement.style.setProperty(
        HEALTH_NAV_OFFSET_CSS_VAR,
        `${Math.ceil(nav.getBoundingClientRect().height)}px`
    );
}

export function getHealthFixedNavOffsetPx(): number {
    if (typeof window === "undefined") {
        return HEALTH_NAV_OFFSET_FALLBACK_PX;
    }

    const fromVar = Number.parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
            HEALTH_NAV_OFFSET_CSS_VAR
        )
    );
    if (Number.isFinite(fromVar) && fromVar > 0) {
        return Math.ceil(fromVar);
    }

    const nav = document.querySelector<HTMLElement>("[data-site-nav]");
    if (nav) {
        return Math.ceil(nav.getBoundingClientRect().height);
    }

    return HEALTH_NAV_OFFSET_FALLBACK_PX;
}

export function useHealthNavOffsetSync(
    ref: RefObject<HTMLElement | null>,
    deps: unknown[] = []
): void {
    useLayoutEffect(() => {
        const sync = () => syncHealthNavOffsetCssVar(ref.current);
        sync();
        window.addEventListener("resize", sync);
        return () => window.removeEventListener("resize", sync);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
